import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { loadStoreState, setInitialStoreState } from '../../../../../common/utils';
import { PlantItemFacade } from './plant-item.facade';

@Injectable({
  providedIn: 'root',
})
export class PlantItemGuard {
  constructor(private plantItemFacade: PlantItemFacade) {}

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    const {
      params: { plantId },
    } = route;
    return loadStoreState(this.plantItemFacade, plantId);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.plantItemFacade);
  }
}
